import { type OpenApiSchemaCategory } from '#shared/api/schema';
import { createMapFromArray } from '#shared/lib/array';

/*
 * Функция создает мапу категорий для быстрого доступа
 * @param categories
 */
export function createCategoryMap(categories: OpenApiSchemaCategory[]): Map<string, OpenApiSchemaCategory> {
    return createMapFromArray(categories, (item) => [item.id, item]);
}
